import { useEffect } from 'react'
import { QueryStatus } from '../../hooks/useQuery'
import EventsEngine from '../../../engines/EventsEngine'

interface P {
    status: QueryStatus
}

function StaleObserver({ status }: P) {
    useEffect(() => {
        if (status === 'stale') EventsEngine.publish('loading-stale-data')
        else EventsEngine.publish('loaded-stale-data')

        return () => EventsEngine.publish('loaded-stale-data')
    }, [status])

    return null
}

export default StaleObserver
